import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-view-application-status-details',
  template: `<button  class="btn btn-outline-primary btn-sm btnEdit" (click)="btnClickedHandler()" data-bs-toggle="modal" data-bs-target="#exampleModal"><i  class="bi bi-pencil-square tblbtn"></i></button>`,
  styles: [
  ]
})
export class ViewApplicationStatusDetailsComponent implements ICellRendererAngularComp {

  appId: any;
  
  agInit(params: ICellRendererParams): void {
    this.appId = params;
  }
  refresh(params: ICellRendererParams): boolean {
    return false;
  }
  btnClickedHandler() {
    this.appId.clicked(this.appId.value);
  }
}
